import { render, staticRenderFns } from "./ApexScatterChart.vue?vue&type=template&id=2b67e2c0&"
import script from "./ApexScatterChart.vue?vue&type=script&lang=js&"
export * from "./ApexScatterChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports